import * as Yup from 'yup';
import assistantsFormModel from './assistantsFormModel';

const {
  formField: {
    name,
    description,
    service_id,
    systemPrompt,
    welcomeMessage,
    temperature,
    topP,
    maxTokens,
    avatar,
    icon,
    color,
    visibility,
    isPublic,
    allowHistory,
    allowImages,
    allowAudio,
    allowFileUpload,
    maxMessagesPerDay,
    maxContextMessages,
  },
} = assistantsFormModel;

export default [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg).max(255, 'Máximo 255 caracteres'),
    [description.name]: Yup.string().optional(),
    [service_id.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined)
      .required(service_id.requiredErrorMsg),
    [systemPrompt.name]: Yup.string().optional(),
    [welcomeMessage.name]: Yup.string().optional(),
    [temperature.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(0, 'Mínimo 0')
      .max(2, 'Máximo 2')
      .optional()
      .nullable(),
    [topP.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(0, 'Mínimo 0')
      .max(1, 'Máximo 1')
      .optional()
      .nullable(),
    [maxTokens.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(1, 'Mínimo 1')
      .optional()
      .nullable(),
    [avatar.name]: Yup.string().max(500).optional().nullable(),
    [icon.name]: Yup.string().max(100).optional().nullable(),
    [color.name]: Yup.string().max(20).optional().nullable(),
    [visibility.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .optional()
      .nullable(),
    [isPublic.name]: Yup.boolean().optional(),
    [allowHistory.name]: Yup.boolean().optional(),
    [allowImages.name]: Yup.boolean().optional(),
    [allowAudio.name]: Yup.boolean().optional(),
    [allowFileUpload.name]: Yup.boolean().optional(),
    [maxMessagesPerDay.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(1)
      .optional()
      .nullable(),
    [maxContextMessages.name]: Yup.number()
      .typeError('Debe ser un número')
      .min(1)
      .optional()
      .nullable(),
  }),
];
